<template>
	<div id="plangraduate">
		<HrrBreadcrumb PMname="岗位计划管理" CMname="军转业岗位管理" />
		<HrrDetailLayout>
			<template slot="head" >
				{{title}}
			</template>
			<template slot="Form" >
				<el-form status-icon :model="postform" ref="postform" :rules="postrules" label-width="110px" class="el-form-module" :hide-required-asterisk="!isAddOrEdit" >
                    <el-row :gutter="20">
                        <el-col :span="8">
							<el-form-item label="计划：" prop="planId">
								<el-select v-model="postform.planId" placeholder="请选择" :disabled="!isAddOrEdit">
									<el-option v-for="item in planIdData" :key="item.planId" :label="item.planName" :value="item.planId" >
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="部门：" prop="orgId">
	                        <el-select v-model="postform.orgId" placeholder="请选择" filterable :disabled="!isAddOrEdit" >
	                            <el-option
	                                v-for="item in orgIdData"
	                                :key="item.orgId"
	                                :label="item.orgName"
	                                :value="item.orgId"
	                                :disabled="item.disabled">
	                                <span >{{item.s+item.orgName}}</span>
	                            </el-option>
	                        </el-select>
	                    </el-form-item>
                            <el-form-item label="岗位名称：" prop="post">
                                <el-input v-model="postform.post" v-if="isAddOrEdit"></el-input>
                                <span v-if="!isAddOrEdit">
                                    {{postform.post}}
                                </span>
                            </el-form-item>
                            <el-form-item label="岗位简介：" prop="postDesc">
                                <el-input v-model="postform.postDesc" v-if="isAddOrEdit" type="textarea"></el-input>
                                <span v-if="!isAddOrEdit">
                                    {{postform.postDesc}}
                                </span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                        	<el-form-item label="专业：" prop="major">
                                <el-input v-model="postform.major" v-if="isAddOrEdit"></el-input>
                                <span v-if="!isAddOrEdit">
                                   {{postform.major}}
                                </span>
                            </el-form-item>
                            <el-form-item label="学历要求：" prop="educationType">
                                <el-select v-model="postform.educationType" placeholder="请选择" v-if="isAddOrEdit">
                                    <el-option	v-for="item in educationTypeDta"	:key="item.typeValue"	:label="item.typeName"
                                    :value="item.typeName">
                                    </el-option>
                                </el-select>
                                <span v-if="!isAddOrEdit">
                                    {{postform.educationType}}
                                </span>
                            </el-form-item>
                            <el-form-item label="学位要求：" prop="diplomaType">
                                <el-select v-model="postform.diplomaType" placeholder="请选择" v-if="isAddOrEdit">
                                    <el-option	v-for="item in diplomaTypeData"	:key="item.typeValue"	:label="item.typeName"
                                    :value="item.typeName">
                                    </el-option>
                                </el-select>
                                <span v-if="!isAddOrEdit">
                                    {{postform.diplomaType}}
                                </span>
                            </el-form-item>
                            <el-form-item label="其他条件：" prop="other">
                                <el-input v-model="postform.other" v-if="isAddOrEdit" type="textarea"></el-input>
                                <span v-if="!isAddOrEdit">
                                    {{postform.other}}
                                </span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
							<el-form-item label="政治面貌：" prop="politicalType">
                                <el-select v-model="postform.politicalType" placeholder="请选择" v-if="isAddOrEdit">
                                    <el-option	v-for="item in politicalTypeData"	:key="item.typeValue"	:label="item.typeName"
                                    :value="item.typeValue">
                                    </el-option>
                                </el-select>
                                <span v-if="!isAddOrEdit">
                                    {{postform.politicalType}}
                                </span>
                            </el-form-item>
                            <el-form-item label="备注：" prop="remark">
                                <el-input v-model="postform.remark" v-if="isAddOrEdit" type="textarea"></el-input>
                                <span v-if="!isAddOrEdit">
                                    {{postform.remark}}
                                </span>
                            </el-form-item>
                        </el-col>
                    </el-row>
				</el-form>
			</template>
			<template slot="buttons" >
				<el-button type="primary" @click="submitMForm('postform')" v-if="isAddOrEdit">提 交</el-button>
				<el-button  @click="resetMForm('postform')" v-if="isAddOrEdit">重 置</el-button>
				<el-button type="info" @click="returnMForm()" >返 回</el-button>
			</template>
		</HrrDetailLayout>
	</div>
</template>
<script>
	export default {
		name: 'plan_graduates_Detail',
		data(){
			return{
				postform:{
					planId:"",
					orgId:"",
					soldierId:"",
					post:"",
					major:"",
					educationType:"",
					politicalType:"",
					diplomaType:"",
                    postDesc:"",
					status:0,
				},
				postrules:{
					post:[ { required: true, message: '请输入岗位名称' , trigger: 'blur'}],
					major:[ { required: true, message: '请输入专业' , trigger: 'blur'}],
                    educationType:[ { required: true, message: '请选择学历要求' , trigger: 'blur'}],
                    politicalType:[ { required: true, message: '请选择学位要求' , trigger: 'blur'}],
                    diplomaType:[ { required: true, message: '请选择政治面貌' , trigger: 'blur'}],
                    planId:[ { required: true, message: '请选择计划' , trigger: 'blur'}],
                    orgId:[ { required: true, message: '请选择部门' , trigger: 'blur'}]
				},
				title:"",
				planIdData: [],
				orgIdData:[],
				isAddOrEdit:true,
                educationTypeDta:[],
				diplomaTypeData:[],
				politicalTypeData:[]
			}
		},
		methods:{
			submitMForm:function(formName){
                var Hrrtype=this.$route.params.type; //类型
                if(Hrrtype=="edit"){Hrrtype="modify"}
				this.$refs[formName].validate((valid) =>{
					if (valid) {
						var loading = this.$loading({
							lock: true,
							text: '提交中...',
							spinner: 'el-icon-loading',
							background: 'rgba(0, 0, 0, 0.7)'
						});
						var Vuethis=this;
						// console.log(Hrrtype)
						var postUrl = (Hrrtype == "modify") ? this.$api.plan.soldiermodify : this.$api.plan.soldierAdd ;
						this.$hrraxios.post(postUrl,this.postform)
						.then(function(response){
							loading.close();
							var data=response.data;
							console.log(data)
							if(data.success==true)
							{
								Vuethis.$alert("提交成功！",{callback:action=>{
									Vuethis.$router.push({path:'/plan/soldier'});
								}});
							}
						}).catch(function(error){
							loading.close();
							console.log(error);
						})
					} else {
						return false;
					}
				});
			},
			resetMForm:function(formName) {
				this.$refs[formName].resetFields();
			},
			returnMForm:function(){
				this.$router.go(-1);
			},
			initData:function(){
				var Vuethis = this;
				var Hrrtype=this.$route.params.type; //类型
				if(Hrrtype!="add"){
					var row=this.$route.meta.row;
					this.$route.meta.row={};
					// console.log(row)
					this.postform=row;
				}
				if(Hrrtype=="view"){
					this.title="查看军转业岗位";
					this.isAddOrEdit=false;
				}
				if(Hrrtype=="edit"){
					this.title="编辑军转业岗位";
					this.isAddOrEdit=true;

				}
				if(Hrrtype=="add"){
					this.title="新增军转业岗位";
					this.isAddOrEdit=true;
				}
			},
			initParamsData(){
                this.$common.getplanlist(this,"planIdData");
                this.$common.getOrganizationTree(this,this.orgIdData);
                this.$common.getType({typeFortable:"Hrr_post",typeForfield:"Education_Type"},"educationTypeDta",this);
                this.$common.getType({typeFortable:"Hrr_post",typeForfield:"Diploma_Type"},"diplomaTypeData",this);
                this.$common.getType({typeFortable:"Hrr_post",typeForfield:"Political_Type"},"politicalTypeData",this);
            } 

		},
		created:function(){
			this.initData();
			this.initParamsData();
		}
	}
</script>
<style scoped>
.el-form-module,.el-select{width:100%;}
</style>
